module.exports = __webpack_public_path__ + "img/bannerpublicidad.8fe9ea56.png";